var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftSmArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right 1",
    clipPath: "url(#clip0_345_8773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0094 19.7064C15.5086 20.1382 16.2667 20.0878 16.7031 19.5942C17.139 19.1002 17.088 18.35 16.5893 17.9182L8.02168 10.5002L16.5897 3.08175C17.0889 2.64992 17.1395 1.89977 16.7035 1.40619C16.2671 0.91218 15.5091 0.861738 15.0099 1.29356L5.41001 9.6061C5.14942 9.83137 5 10.1575 5 10.5002C5 10.8429 5.14942 11.1686 5.41001 11.3943L15.0094 19.7064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0094 19.7064C15.5086 20.1382 16.2667 20.0878 16.7031 19.5942C17.139 19.1002 17.088 18.35 16.5893 17.9182L8.02168 10.5002L16.5897 3.08175C17.0889 2.64992 17.1395 1.89977 16.7035 1.40619C16.2671 0.91218 15.5091 0.861738 15.0099 1.29356L5.41001 9.6061C5.14942 9.83137 5 10.1575 5 10.5002C5 10.8429 5.14942 11.1686 5.41001 11.3943L15.0094 19.7064Z",
    fill: "url(#paint0_linear_345_8773)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_345_8773",
    x1: 5.37037,
    y1: -12.7019,
    x2: 19.9046,
    y2: -11.6926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A92902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#E25704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49004"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345_8773"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(22 22) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSmArrow);
export default __webpack_public_path__ + "static/media/left-sm-arrow.26842ef7d25a631fdb539befe4b412e6.svg";
export { ForwardRef as ReactComponent };